import React, { useEffect, useState } from "react";
import PropertyAuctionCard from "./PropertyAuctionCard";
import { DateTime } from "luxon";
import { useRouter } from "next/router";
import NoLiveAuctionEventComponent from "../auctionFloor/NoLiveAuctionEventComponent";
import { useSelector } from "react-redux";
import AuctionParticipationTncModel from "./AuctionParticipationTncModel";
interface PropertyAuctionCardWrapperProps {
  activeTabData: {
    name: string;
    key: string;
    data: Array<any>;
  };
  setOpenDetailsTab: any;
  setOpenCancelledEventModal: any;
}

export default function PropertyAuctionCardWrapper({
  activeTabData,
  setOpenDetailsTab,
  setOpenCancelledEventModal,
}: PropertyAuctionCardWrapperProps) {
  const router = useRouter();
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const [isOpen, setIsOpen] = useState(false);
  const [eventId, setEventId] = useState("");
  const [eventStatus, setEventStatus] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setEventId("");
      setEventStatus("");
    }
  }, [isOpen]);

  const auctionEventKayValueData = (event: any) => {
    const userId = onboardingData?.user_uuid;
    const eligibleBidderData = event?.bidders?.find(
      (data: any) => data?.user_uuid === userId,
    );
    const isSwissEvent = event?.event_type === "Asset transfer";
    const data = [];
    if (isSwissEvent) {
      data.push({
        key: "Binding Bid",
        value: eligibleBidderData?.meta?.initial_bid_price
          ? `₹ ${eligibleBidderData?.meta?.initial_bid_price || "Na"}`
          : "Na",
      });
    } else {
      data.push({
        key: "EMD Amount",
        value: `₹ ${event.property_dump?.emd_amount}`,
      });
    }
    return [
      {
        key: "Event Name",
        value: event?.event_name?.slice(0, 20),
      },
      {
        key: "State",
        value: event.property_dump.state.name,
      },
      {
        key: "Reserve Price",
        value: `₹ ${event.property_dump?.reserve_price}`,
      },
      ...data,
    ];
  };

  const pastEventsButtonClickHandler = async (eventData: any) => {
    setOpenDetailsTab(eventData);
  };
  const liveEventsButtonClickHandler = async (eventData: any) => {
    if (!eventData?.uuid) {
      console.error("Invalid event data");
      return;
    }
    setIsOpen(true);
    setEventId(eventData.uuid);
    setEventStatus(eventData.status);
    // window.open(`/auction-events/${eventData.uuid}`, "_blank");
  };

  const cancelledEventsButtonClickHandler = async (eventData: any) => {
    setOpenCancelledEventModal(eventData);
  };

  const getAssetTypeTextFromData = (data: any) => {
    const asset = data?.property_dump?.asset?.name || "Na";
    const sub_asset_type = data?.property_dump?.sub_asset_type.name || "Na";
    return `${asset} - ${sub_asset_type}`;
  };
  const getTagNameFromTabData = () => {
    let tagStatus;
    switch (activeTabData.key) {
      case "upcoming_events":
        tagStatus = null;
        break;

      case "live_events":
        tagStatus = "Live auction";
        break;
      case "past_events":
        tagStatus = "auction ended";
        break;

      case "cancelled_events":
        tagStatus = "cancelled";
        break;
      case "bid_application":
        tagStatus = null;
        break;

      default:
        tagStatus = "Auction Event";
        break;
    }
    return tagStatus;
  };

  const getLocationFromPropertiesData = (property: any) => {
    return `${property.property_dump.city.name}, ${property.property_dump.state.name}`;
  };

  const getAuctionTime = (dateTime: any) => {
    return `${DateTime.fromISO(dateTime)
      .setZone("Asia/Kolkata")
      .toFormat("dd MMMM yyyy")} ${DateTime.fromISO(dateTime)
      .setZone("Asia/Kolkata")
      .toFormat("hh:mm a")} (IST)`;
  };
  const onAgreeAndContinue = async (eventId: string, eventStatus: string) => {
    console.log("onAgreeAndContinue");
    if (!eventId) {
      console.error("Invalid event ID or status", eventId, eventStatus);
      return;
    }
    window.open(`/auction-events/${eventId}`, "_blank");
    setIsOpen(false);
    setEventId("");
    setEventStatus("");
  };

  return (
    <div>
      <div className="flex flex-col gap-6">
        {activeTabData?.data?.length > 0 ? (
          activeTabData?.data?.map((eventData, index) => {
            const eligibleBidderData = eventData?.bidders?.find(
              (data: any) => data?.user_uuid === onboardingData?.user_uuid,
            );
            let kycStatus = "Incomplete Application";
            if (eligibleBidderData?.created_by === "banker") {
              kycStatus =
                eligibleBidderData?.status === "verified"
                  ? "Verified Application"
                  : "Incomplete Application";
            } else {
              if (eligibleBidderData?.status === "verified") {
                kycStatus = "Verified Application";
              } else if (eligibleBidderData?.status === "rejected") {
                kycStatus = "Banker Rejected";
              } else if (
                eligibleBidderData?.digio_request_status === "approved"
              ) {
                kycStatus = "Awaiting Banker Approval";
              }
            }
            return (
              <PropertyAuctionCard
                key={`PropertyAuctionCard_${index}`}
                bidderUuid={eligibleBidderData?.uuid}
                rejectionReason={eligibleBidderData?.remarks || null}
                fileUuid={
                  eligibleBidderData?.digio_kyc_data?.file_uuid ||
                  eligibleBidderData?.esigned_data?.file_uuid ||
                  null
                }
                userType={eligibleBidderData?.created_by || "banker"}
                activeTabKey={activeTabData.key}
                // headingText="Residential Flat "
                headingText={getAssetTypeTextFromData(eventData)}
                listingId={eventData?.listing_id}
                tagText={getTagNameFromTabData()}
                secondaryTagText={
                  eventData?.status === "live"
                    ? "Live"
                    : eventData?.status === "end"
                    ? "Ended"
                    : null
                }
                subHeadingText={getLocationFromPropertiesData(eventData)}
                imgLink={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
                  process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
                    ? "27f785cc-24cb-4531-9b91-4a6c58bfaf37"
                    : "771263b2-a630-46f2-ae99-24cece88c4be"
                }`}
                AuctionEventKeyValueData={auctionEventKayValueData(eventData)}
                kycStatus={kycStatus}
                ctaProps={{
                  ctaText:
                    activeTabData.key === "past_events"
                      ? "View Details"
                      : activeTabData.key === "live_events"
                      ? eligibleBidderData?.access_type === "viewer"
                        ? "View Auction"
                        : "Start bidding"
                      : activeTabData.key === "upcoming_events"
                      ? eligibleBidderData?.access_type === "viewer"
                        ? "View Auction"
                        : "Start bidding"
                      : activeTabData.key === "bid_application"
                      ? "Complete Now!"
                      : "View Details",
                  ctaHandler: async () => {
                    if (activeTabData.key === "past_events") {
                      await pastEventsButtonClickHandler(eventData);
                      return;
                    } else if (activeTabData.key === "live_events") {
                      await liveEventsButtonClickHandler(eventData);
                      return;
                    } else if (activeTabData.key === "cancelled_events") {
                      await cancelledEventsButtonClickHandler(eventData);
                      return;
                    }
                  },
                  disabled: activeTabData.key === "upcoming_events",
                  ctaStyle:
                    "bg-brand-textBlack text-white hover:bg-brand-textBlack hover:text-white",
                }}
                biddingDetails={{
                  startDate: getAuctionTime(eventData.start_date_time),
                  endDate: getAuctionTime(eventData.end_date_time),
                  style: {
                    cardBackgroundImage: "bg-custom-card-grey",
                    cardLeftBorderColor: "border-brand-textBlack",
                  },
                }}
                style={{
                  imgStyle: "w-full h-[295px] lg:w-[210px] lg:h-[190px]",
                  tagStyle: "bg-[#F1EAFF] text-[#5D5FEF]",
                }}
              />
            );
          })
        ) : (
          <div className="min-h-[250px] flex justify-center items-center font-sans text-sm font-semibold bg-white">
            {activeTabData.key === "live_events" ? (
              <NoLiveAuctionEventComponent />
            ) : (
              <div className="capitalize text-brand-orange mx-10 text-center">{`Looks like the stage for ${activeTabData.name} is empty for now. Stay tuned for updates!`}</div>
            )}
          </div>
        )}
      </div>
      <AuctionParticipationTncModel
        onAgreeAndContinue={onAgreeAndContinue}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        eventId={eventId}
        eventStatus={eventStatus}
      />
    </div>
  );
}
